<template>
  <div class="w-full">
    <div
      :style="{ backgroundImage: 'url(/img/cloud-bg.jpg)' }"
      class="h-120 bg-cover bg-center w-full relative z-10 text-white pb-60 flex flex-col overflow-x-hidden"
    ></div>
    <div
      :style="{ minHeight: '450px' }"
      class="bg-truegray-100 w-full pb-16 flex flex-col items-center lg:items-start"
    >
      <div
        :style="{ minHeight: '450px' }"
        class="rounded-xl lg:ml-16 -mt-48 relative z-20 py-16 px-6 lg:p-16 flex w-11/12 lg:w-9/12 transition-all duration-500"
        :class="[
          loading ? 'bg-truegray-500 items-center justify-center' : 'bg-white',
          loading && !mounting ? 'delay-500' : '',
        ]"
      >
        <div
          v-if="loading"
          class="h-48 w-48 absolute right-1/2 bottom-1/2 transform translate-x-1/2 translate-y-1/2"
        >
          <lottie :options="loadingAnimationOptions" />
        </div>
        <PostContent v-if="content" :category="category" :data="content" />
      </div>
    </div>
  </div>
</template>

<script>
import { shared } from '../js/mixins/shared.js'
import PostContent from './online/components/PostContent.vue'
import * as loadingAnimation from '../shared/components/loading.json'

export default {
  components: {
    PostContent,
  },

  mixins: [shared],

  props: {
    news_id: {
      default: 0,
    },

    resource_id: {
      default: false,
    },
  },

  data() {
    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },

      loadingAnimate: false,

      loading: false,

      mounting: true,

      window: {
        width: 0,
        height: 0,
      },

      content: false,

      category: false,

      endpoint: false,
    }
  },

  watch: {
    post_id: {
      handler: function (id) {
        this.getPost(id)
      },

      deep: true,
    },

    endpoint: {
      handler: function () {
        this.getContent()
      },

      deep: true,
    },
  },

  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },

  mounted() {
    this.$set(this, 'mounting', true)

    if (this.news_id) {
      this.$set(this, 'endpoint', '/cloudpost/' + this.news_id)
      this.$set(this, 'category', 'post')
    }

    if (this.resource_id) {
      this.$set(this, 'endpoint', '/resource/' + this.resource_id)
      this.$set(this, 'category', 'resource')
    }
  },

  unmounted() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    handleResize() {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },

    getContent() {
      if (this.endpoint === false) {
        return
      }

      this.$set(this, 'loading', true)
      axios.get('/api' + this.endpoint).then((response) => {
        this.$set(this, 'loading', false)
        let result = response.data
        if (result.success) {
          this.$set(this, 'content', result.post)
        }
        this.$set(this, 'loading', false)
      })
    },
  },
}
</script>

<style scoped>
.post-intro::after {
  content: '';
  background: #fff;
  height: 1px;
  width: 500px;
  min-width: 95%;
  position: absolute;
  top: 4rem;
  right: 0;
}
</style>
